import { useEffect } from 'react';

import { useBrandVoicesActions, useCurrentWorkspaceId } from 'src/store';

/**
 * This hook is maintaining the "brand voice" store state.
 */
export const useMaintainBrandVoicesStoreState = () => {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const brandVoicesActions = useBrandVoicesActions();

  useEffect(() => {
    if (!currentWorkspaceId) {
      return;
    }

    // Create an abort controller, in case user selects another workspace before the fetch completes
    const abortController = new AbortController();

    // Fetch brand voices for the current workspace
    brandVoicesActions.queryWorkspaceBrandVoices(
      { workspaceId: currentWorkspaceId },
      {
        abortSignal: abortController.signal,
      }
    );

    // Fetch brand voice assets for the current workspace
    brandVoicesActions.queryBrandVoicesAssets(
      { workspaceId: currentWorkspaceId },
      {
        abortSignal: abortController.signal,
      }
    );

    // Clear the store when the workspace changes
    return () => {
      abortController.abort();
      brandVoicesActions.clearStore();
    };
  }, [currentWorkspaceId, brandVoicesActions]);
};
